import * as React from "react";
import "./CollapseCtl.scss";
import { Guid } from "@testout/testout-commerce/core/Guid";

interface ICollapseProps {
    mainLine: React.ReactNode;
    itemId: Guid;
    hidden: boolean;
    isOpen: boolean;
    onChange: (itemId: Guid) => void;
}

export default class CollapseCtl extends React.PureComponent<ICollapseProps> {
    render() {
        return <div>
            {!this.props.hidden && <div>
                <div className="collapse">
                    <button onClick={() => this.props.onChange(this.props.itemId) }>
                        <div style={{ width: '7px', transform: `rotate(${this.props.isOpen ? "90" : "0"}deg)`, margin: '10px 7px 0 5px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.5 21.1">
                                <path d="M2 2l7.5 8.5-7.4 8.6" fill="none" stroke="#00a4bd" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4"></path>
                            </svg>
                        </div>
                    </button>
                    <div className="collapseMainLine">{this.props.mainLine}</div>
                </div>
                {this.props.isOpen && <div className="collapseContent">{this.props.children}</div>}
            </div>}
            {this.props.hidden && <div className="collapseMainLine">{this.props.mainLine}</div>}
        </div>;
    }
}